(function () {
    'use strict';

    function zipbuilderDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/zipbuilder';
        var svc = this;
        svc.sessionData = null;

        function build(data) {
            return $http.post(baseUrl, data).then(function (response) {
                return response.data.BlobReference;
            });
        };

        return {
            build: build
        }
    }

    zipbuilderDataService.$inject = ['$http'];

    angular.module('ecap.common').service('zipbuilderDataService', zipbuilderDataService);
})();
